"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LinkTab_styled_exports = {};
__export(LinkTab_styled_exports, {
  StyledLinkTab: () => StyledLinkTab
});
module.exports = __toCommonJS(LinkTab_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_baseTheme = __toESM(require("../../../../themes/baseTheme"));
var import_Tab = require("../Tab/Tab.styled");
var linkDisabledStyles = (0, import_styled_components.css)(["cursor:default;pointer-events:none;"]);
var onHover = (0, import_styled_components.css)(["&:hover{text-decoration:underline;color:", ";}"], import_baseTheme.default.colors.pr.base);
var StyledLinkTab = import_styled_components.default.a.withConfig({
  displayName: "LinkTabstyled__StyledLinkTab",
  componentId: "sc-10cjaun-0"
})(function(_ref) {
  var theme = _ref.theme, selected = _ref.selected, isDisabled = _ref.isDisabled, fontSize = _ref.fontSize, isBold = _ref.isBold, customStyle = _ref.customStyle;
  return [(0, import_styled_components.css)(["", " cursor:pointer;min-height:40px;min-width:104px;text-decoration:none;", " ", " &:focus{", ";*{text-decoration:underline;color:", ";}", "}:active{background-color:", ";outline:none;*{color:", ";text-decoration:underline;}}"], (0, import_Tab.tabStyles)({
    selected,
    isDisabled,
    fontSize,
    isBold
  }), isDisabled && linkDisabledStyles, !isDisabled && onHover, selected ? import_Tab.focusSelectedStyles : import_Tab.tabFocusStyles, theme.colors.pr.base, isDisabled && (0, import_styled_components.css)(["*{color:", ";text-decoration:none;}"], import_baseTheme.default.colors.n[60]), isDisabled ? "transparent" : theme.colors.beige[100], theme.colors.n[100]), customStyle || (0, import_styled_components.css)([""])];
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledLinkTab
});
//# sourceMappingURL=LinkTab.styled.js.map